export default __webpack_public_path__ + "static/media/08AW2MAR66.253d7d62.jpg";